<script>
  export let downloading;
</script>

<div>
  <!-- REACH FIXME: Add dynamic OG image functionality for Twitter cards, and link it here-->
  {#if downloading}
    <img src="/images/emojis/hourglass.png" alt="Downloading" />
  {:else}
    <img src="/images/emojis/down.png" alt="Download" />
  {/if}
</div>

<style>
  div {
    position: absolute;
    bottom: 0;
    left: 0%;
    transform: translateY(115%);
    display: flex;
    z-index: 100;
  }

  img {
    width: max(3vw, 30px);
  }
</style>
